import type { Video } from "@brookbush/types";

import {
	CaptionsIcon,
	LibraryIcon,
	ListIcon,
	MessagesSquareIcon,
} from "lucide-react";

import AppBar from "~/components/AppBar";
import type { IAppBarItem } from "~/components/AppBar/AppBar";

type Props = {
	video: Video;
	setSelectedIndex: (index: number) => void;
};

const VideoAppBar = ({ video, setSelectedIndex }: Props) => {
	const items = [
		{
			label: "Related",
			icon: LibraryIcon,
			onClick: () => {
				setSelectedIndex(0);
				window.scrollTo(
					0,
					document.getElementById("related-videos")!.scrollHeight + 210,
				);
			},
		},

		!!video.instructions?.length && {
			label: "Instructions",
			icon: ListIcon,
			onClick: () => {
				setSelectedIndex(1);

				window.scrollTo(
					0,
					document.getElementById("video-instructions")!.scrollHeight + 210,
				);
			},
		},

		!!video.captions?.length && {
			label: "Transcript",
			icon: CaptionsIcon,
			onClick: () => {
				setSelectedIndex(video.instructions?.length ? 2 : 1);
				window.scrollTo(
					0,
					document.getElementById("video-transcript")!.scrollHeight + 210,
				);
			},
		},

		{
			label: "Comments",
			icon: MessagesSquareIcon,
			href: "#video-comments",
		},
	].filter(Boolean) as IAppBarItem[];

	return <AppBar items={items} />;
};

export default VideoAppBar;
